var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBestClass(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 42,
    height: 42
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "best-class_svg__a",
    x1: "0%",
    x2: "100%",
    y1: "100%",
    y2: "0%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#F5515F",
    stopOpacity: 0.008
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#9F0469",
    stopOpacity: 0.219
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "best-class_svg__b",
    x1: "0%",
    x2: "100%",
    y1: "100%",
    y2: "0%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#F5515F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#9F0469"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "best-class_svg__c",
    x1: "0%",
    x2: "100%",
    y1: "93.206%",
    y2: "6.794%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#F5515F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#9F0469"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "best-class_svg__d",
    x1: "100%",
    x2: "25.719%",
    y1: "6.794%",
    y2: "57.839%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#A50968"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#E74461"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "best-class_svg__e",
    x1: "100%",
    x2: "25.719%",
    y1: "0%",
    y2: "59.072%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#A50968"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#E74461"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 42,
    height: 42,
    fill: "url(#best-class_svg__a)",
    rx: 21
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(11 11)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 19.54,
    cy: 19.524,
    r: 1,
    fill: "url(#best-class_svg__b)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#best-class_svg__c)",
    stroke: "url(#best-class_svg__d)",
    strokeWidth: 0.2,
    d: "M17.952 3.075a2.157 2.157 0 012.164 2.163h0v7.937a.574.574 0 01-.166.41.574.574 0 01-.41.166.573.573 0 01-.577-.576h0V8.67H13.73c-.263 0-.544-.121-.737-.315h0l-1.713-1.71a.404.404 0 01-.098-.453.411.411 0 01.388-.26h7.392v-.694a1.006 1.006 0 00-1.011-1.011h0-8.73a.574.574 0 01-.41-.166.574.574 0 01-.166-.41h0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#best-class_svg__b)",
    stroke: "url(#best-class_svg__e)",
    strokeWidth: 0.2,
    d: "M.47-.1c.117 0 .236.037.337.11L.88.072l17.14 17.14a.54.54 0 01.175.401c0 .136-.05.274-.149.386l-.084.078-1.832-1.152H1.81c-.52 0-.993-.213-1.337-.557a1.897 1.897 0 01-.55-1.165l-.007-.171V5.238c0-.599.241-1.14.632-1.53a2.152 2.152 0 011.136-.598l.192-.026L.07.878C-.1.474-.1.465-.1.456l.012-.02C.185-.082.332-.1.47-.1zm7.41 8.771H1.067v6.36l.01.12a.738.738 0 00.209.403c.135.135.32.219.523.219h13.17l-7.1-7.102zM3.434 4.227H2.079l-.138.01a1.002 1.002 0 00-.873 1.001h0v.694H5.14L3.435 4.227z"
  })))));
}
export default SvgBestClass;